import { useEffect, useRef, useState } from 'react';

interface UseApiDataResult<T> {
  data: T | undefined;
  isLoading: boolean;
}

function useApiData<T>(fetcher: () => Promise<T>): UseApiDataResult<T> {
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  const [data, setData] = useState<T>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    fetcherRef.current()
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, isLoading };
}

export { useApiData };
